module.exports = __webpack_public_path__ + "img/grey-arrow.7ed98743.svg";